import { IconButton, IconButtonProps } from "@chakra-ui/button"
import { Box } from "@chakra-ui/layout";
import { Tooltip } from "@chakra-ui/tooltip";
import { EmbedIcon } from "lib/icons/embed";
import { FC } from "react";

interface Props extends Partial<IconButtonProps> {
  isEmbedded: boolean;
}

export const IconButtonEmbed:FC<Props>  = ({ isEmbedded, ...rest }) => (
  <Tooltip
    label={isEmbedded ? 'Unembed' : 'Embed'}
    openDelay={600}
    closeOnMouseDown
    hasArrow
  >
    <Box>
      <IconButton variant="primary" size="sm" aria-label="Change view" {...rest}>
        <EmbedIcon boxSize="16px" />
      </IconButton>
    </Box>
  </Tooltip>
);
